import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/uninstall.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm uninstall [<@scope>/]<pkg>...

aliases: unlink, remove, rm, r, un
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/uninstall.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`This uninstalls a package, completely removing everything npm installed
on its behalf.`}</p>
    <p>{`It also removes the package from the `}<inlineCode parentName="p">{`dependencies`}</inlineCode>{`, `}<inlineCode parentName="p">{`devDependencies`}</inlineCode>{`,
`}<inlineCode parentName="p">{`optionalDependencies`}</inlineCode>{`, and `}<inlineCode parentName="p">{`peerDependencies`}</inlineCode>{` objects in your
`}<inlineCode parentName="p">{`package.json`}</inlineCode>{`.`}</p>
    <p>{`Further, if you have an `}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{` or `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{`, npm
will update those files as well.`}</p>
    <p><inlineCode parentName="p">{`--no-save`}</inlineCode>{` will tell npm not to remove the package from your
`}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{`, or `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` files.`}</p>
    <p><inlineCode parentName="p">{`--save`}</inlineCode>{` or `}<inlineCode parentName="p">{`-S`}</inlineCode>{` will tell npm to remove the package from your
`}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{`, and `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` files.
This is the default, but you may need to use this if you have for
instance `}<inlineCode parentName="p">{`save=false`}</inlineCode>{` in your `}<inlineCode parentName="p">{`npmrc`}</inlineCode>{` file`}</p>
    <p>{`In global mode (ie, with `}<inlineCode parentName="p">{`-g`}</inlineCode>{` or `}<inlineCode parentName="p">{`--global`}</inlineCode>{` appended to the command),
it uninstalls the current package context as a global package.
`}<inlineCode parentName="p">{`--no-save`}</inlineCode>{` is ignored in this case.`}</p>
    <p>{`Scope is optional and follows the usual rules for `}<a parentName="p" {...{
        "href": "/cli/v8/using-npm/scope"
      }}><inlineCode parentName="a">{`scope`}</inlineCode></a>{`.`}</p>
    <h3>{`Examples`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm uninstall sax
`}</code></pre>
    <p><inlineCode parentName="p">{`sax`}</inlineCode>{` will no longer be in your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{`, or
`}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` files.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm uninstall lodash --no-save
`}</code></pre>
    <p><inlineCode parentName="p">{`lodash`}</inlineCode>{` will not be removed from your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`,
`}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{`, or `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` files.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`save`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: `}<inlineCode parentName="li">{`true`}</inlineCode>{` unless when using `}<inlineCode parentName="li">{`npm update`}</inlineCode>{` where it defaults to `}<inlineCode parentName="li">{`false`}</inlineCode></li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Save installed packages to a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file as dependencies.`}</p>
    <p>{`When used with the `}<inlineCode parentName="p">{`npm rm`}</inlineCode>{` command, removes the dependency from
`}<inlineCode parentName="p">{`package.json`}</inlineCode>{`.`}</p>
    <p>{`Will also prevent writing to `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` if set to `}<inlineCode parentName="p">{`false`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`include-workspace-root`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Include the workspace root when workspaces are enabled for a command.`}</p>
    <p>{`When false, specifying individual workspaces via the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config, or
all workspaces via the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` flag, will cause npm to operate only on
the specified workspaces, and not on the root project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`install-links`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`When set file: protocol dependencies that exist outside of the project root
will be packed and installed as regular dependencies instead of creating a
symlink. This option has no effect on workspaces.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-prune"
        }}>{`npm prune`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}>{`npm install`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/folders"
        }}>{`npm folders`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/npmrc"
        }}>{`npmrc`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      